import { useEffect, useState } from "react";
import axios from "axios";

import API_URL from "../config/config";
import ProductCard from "./ProductCard";
import "../css/products.css";

function NewArrivals() {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        axios
            .get(`${API_URL}/new-arrivals`)
            .then((res) => {
                console.log("New Arrivals API:", res.data);

                const data = Array.isArray(res.data)
                    ? res.data
                    : res.data.products || res.data.data || [];

                setProducts(data);
            })
            .catch((err) => {
                console.log("New Arrivals Error:", err);
                setProducts([]);
            });
    }, []);

    return (
        <section className="products-section">
            <h2 className="section-title">
                🆕 New Arrivals
            </h2>

            <div className="products-grid">
                {products.map((product) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                    />
                ))}
            </div>
        </section>
    );
}

export default NewArrivals;

